import { Injectable, inject } from "@angular/core";
import { environment } from "../../../../environments/environment";
import { HttpClient } from "@angular/common/http";
import { UserPreference } from "../models/user-preference.model";
import { Observable } from "rxjs";
import { UserDto } from "../models/user.model";

@Injectable({
  providedIn: 'root'
})
export class UserService {
    private http = inject(HttpClient);

    private apiUrl = environment.apiUrl;

    getAllUsers() {
        return this.http.get<UserDto[]>(`${this.apiUrl}/users`);
    }

    getUserById(id: string) {
        return this.http.get(`${this.apiUrl}/users/${id}`);
    }

    getUserPreferences(id: string): Observable<UserPreference> {
        return this.http.get<UserPreference>(`${this.apiUrl}/users/preferences/${id}`);
    }

    updateUserPreferences(id: string, preferences: UserPreference) {
        return this.http.put<UserPreference>(`${this.apiUrl}/users/preferences/${id}`, preferences);
    }
}